import React from 'react'
import { OnboardingWizard } from '../components/onboarding/OnboardingWizard'

export function Onboarding() {
  return <OnboardingWizard />
}
